export const getValue = (source: any, field: string): string => {
  return source.values?.filter(v => v.slug === field)[0]?.value;
};
